<crnt-radio-group [wlTrackValueChange]="valueChangeTrackConfig()">
  <crnt-form-control-label slot="legend">
    {{ control().options.label }}
    @if (showOptional) {
      <crnt-form-control-label-indicator>
        (niet verplicht)
      </crnt-form-control-label-indicator>
    }
  </crnt-form-control-label>
  @if (control().options.helpText) {
    <crnt-form-control-help-text slot="help">
      {{ control().options.helpText }}
    </crnt-form-control-help-text>
  }
  @if (control().hasError()) {
    <rfa-errors slot="validation" [control]="control()"></rfa-errors>
  }

  @for (entry of control().options.entries; track entry; let i = $index) {
    <crnt-radio>
      <input
        type="radio"
        [id]="i + '-' + control().id"
        [formControl]="control()"
        [value]="entry.value"
        [attr.name]="radioGroupName"
        [name]="radioGroupName"
      />
      <label
        slot="label"
        [wlAutomationId]="control().options.dataAutomationId"
        [for]="i + '-' + control().id"
      >
        {{ entry.text }}
      </label>
      @if (entry.helpText) {
        <div slot="help">{{ entry.helpText }}</div>
      }
    </crnt-radio>
  }
</crnt-radio-group>
